export const CLIENT_APP_DOWNLOAD_LINK = {
  ios: 'https://apps.apple.com/au/app/id6761354249',
  android: 'https://play.google.com/store/apps/details?id=au.com.mable.clientapp',
};
